import { SVGProps } from 'react'

export const Youtube = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" fill="none" viewBox="0 0 25 24" {...props}>
    <g clipPath="url(#clip0_145_257)">
      <path
        fill="#05155E"
        d="M24.26 7.2s-.234-1.654-.956-2.38c-.914-.957-1.935-.961-2.404-1.018-3.356-.243-8.396-.243-8.396-.243h-.009s-5.039 0-8.395.243c-.469.057-1.49.061-2.405 1.018C.973 5.546.744 7.2.744 7.2S.5 9.147.5 11.088v1.819c0 1.94.239 3.885.239 3.885s.234 1.655.951 2.382c.914.956 2.114.923 2.649 1.026 1.922.183 8.16.24 8.16.24s5.045-.01 8.4-.25c.47-.055 1.491-.06 2.405-1.016.722-.727.957-2.382.957-2.382s.239-1.94.239-3.886v-1.818c0-1.94-.24-3.886-.24-3.886zm-14.24 7.913V8.368l6.483 3.384-6.483 3.361z"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_145_257">
        <path fill="#fff" d="M0 0H24V24H0z" transform="translate(.5)"></path>
      </clipPath>
    </defs>
  </svg>
)
